export default "__VITE_ASSET__By5UWk7y__"